export const enum ModalConfirmationTypeEnum {
  success = 'success',
  danger = 'danger',
}
